// ** Third Party Components
import styled from "styled-components";

export const StyledSwiperGradient = styled.div`
	position: absolute;
	width: 100%;
	bottom: -1px;
	z-index: 2;
	left: 0;
	width: 100%;
	display: flex;
	padding: 0 1rem;
	background: linear-gradient(
		180deg,
		rgba(0, 0, 0, 0) 0%,
		rgba(0, 0, 0, 0.4) 20%,
		rgba(0, 0, 0, 0.6) 50%,
		rgba(0, 0, 0, 1) 100%
	);
`;
